import moment from 'moment'

export default {
  methods: {
    hasPermission(list) {
      let hasPermission = false
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      if (permissions) {
        list.forEach(element => {
          if (permissions.indexOf(element) >= 0) {
            hasPermission = true
          }
        });
      }
      return hasPermission
    },
    hasRole(list) {
      let hasRole = false
      let roles = JSON.parse(localStorage.getItem('roles'))
      if (roles) {
        list.forEach(element => {
          if (roles.indexOf(element) >= 0) {
            hasRole = true
          }
        });
      }
      return hasRole
    },
    addActivity(data) {
      let activities = this.$store.state.activity.activities
      
      if(activities.filter((i) => i.status == '2' && i.module == data.module).length >= 5){
        this.$vs.notify({
          color: 'warning',
          title: 'Attention',
          text: 'Only up to 5 active processes'
        })
        return 0;
      }
     
      let act = {
        id: this.$uuid.v4(),
        module:data.module,
        name:data.name,
        status: data.status || '2',
        options:data.data || {}
      };

      this.$store.dispatch('activity/add',act).then((res) => {
        this.$vs.notify({
          color: 'warning',
          title: 'Activity',
          text: 'In Process'
        })
      });
      
      return act.id;
    },
    updateActivity(act){
      this.$store.dispatch('activity/update',act);
    },
    showValidationErrors(err) {
      if (err.response.status == 500) {
        this.$vs.notify({
          color: 'danger',
          title: 'Alert',
          text: `SERVER ERROR`
        });
      }
      if (err.response.status == 422) {
        let errors = err.response.data.errors;
        for (let prop in errors) {
          this.$vs.notify({
            color: 'danger',
            //title: 'Alert',
            text: `${errors[prop]}`
          });
        }
      }
    },
    formatNumber: (n = 0 ,decimals = 0) => {
      n = Number(n)
      return n.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits : decimals, minimumFractionDigits : decimals })
    },
    formatDate (date,format = 'L') {
      return moment(date).format(format)
    }
  }
}
